module.exports = __webpack_public_path__ + "img/chica_tenista_bono.07acdb51.jpg";